/**
 * Monta payload no formato de auxiliarData.HealthcareService,
 * restrito ao weekday de hoje (não usa grade semanal da agenda normal).
 */
import dayjs from "dayjs";

export type ProntoDayLabel = "Dom" | "Seg" | "Ter" | "Qua" | "Qui" | "Sex" | "Sab";

const PT_DAYS: ProntoDayLabel[] = [
  "Dom",
  "Seg",
  "Ter",
  "Qua",
  "Qui",
  "Sex",
  "Sab",
];

export function getTodayPtDayLabel(): ProntoDayLabel {
  return PT_DAYS[dayjs().day()];
}

export function todayPtDayLongLabel(): string {
  const map: Record<ProntoDayLabel, string> = {
    Dom: "Domingo",
    Seg: "Segunda-feira",
    Ter: "Terça-feira",
    Qua: "Quarta-feira",
    Qui: "Quinta-feira",
    Sex: "Sexta-feira",
    Sab: "Sábado",
  };
  return map[getTodayPtDayLabel()];
}

/** Converte "HH:mm" em dayjs compatível com useFormatter.formatTime ($H/$m). */
function toDayjsTime(hhmm: string) {
  const [h, m] = hhmm.split(":").map((n) => parseInt(n, 10));
  return dayjs()
    .hour(Number.isFinite(h) ? h : 0)
    .minute(Number.isFinite(m) ? m : 0)
    .second(0)
    .millisecond(0);
}

export interface BuildProntoHcsPayloadParams {
  /** Nome do serviço = especialidade escolhida. */
  specialty: string;
  /** Uma única jornada HH:mm do dia de hoje (sem divisão). */
  intervals: Array<{ start: string; end: string }>;
}

/**
 * Payload esperado por PostHealthcareService / auxiliarData.HealthcareService.
 * PA usa só 1 jornada; timeAvailable[1] fica vazio (exigência do builder legado).
 */
export function buildProntoHealthcareServicePayload(
  params: BuildProntoHcsPayloadParams,
) {
  const day = getTodayPtDayLabel();
  const journey = params.intervals[0];

  const slot0: Record<string, { timeStart: dayjs.Dayjs; timeEnd: dayjs.Dayjs }> =
    {};
  if (journey) {
    slot0[day] = {
      timeStart: toDayjsTime(journey.start),
      timeEnd: toDayjsTime(journey.end),
    };
  }

  return {
    healthService: params.specialty,
    daysOfWeek: [day],
    // [0] = jornada única; [1] = {} — auxiliarData concatena os dois
    timeAvailable: [slot0, {}],
  };
}
